/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, September 2020
 *
 *****************************************************************************/

import React from "react";
import { Marker, InfoWindow } from "react-google-maps";
import { constant } from "./../../../shared/constants/constants";

// show info window/geometry info on clicking on them
const PolygonInfo = ({ pos, onCloseClick, propertyName, propertyId }) => {
  return (
    <Marker visible={false} position={pos}>
      <InfoWindow onCloseClick={onCloseClick}>
        <div>
          <h5>{propertyName}</h5>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`${process.env.REACT_APP_MSA_URL}${constant.PROPERTY_URL}/${propertyId}`}>
            {constant.PROPERTY}
          </a>
        </div>
      </InfoWindow>
    </Marker>
  );
};

export default React.memo(PolygonInfo);
